import React from "react";
import styled from "styled-components";
import {Table} from "antd";

const Wrapper = styled.div`
    border-radius: 10px;
    background-color: white;
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex-wrap: nowrap;
    padding: 16px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
    box-sizing: border-box;
    overflow-x: auto;

    @media screen and (max-width: 768px) {
        padding: 8px;
        margin: 0;
        border-radius: 8px;
        overflow-x: visible;
    }
`;

const StyledTable = styled(Table)`
    width: 100%;

    .ant-table-thead > tr > th {
        font-size: 14px;
        font-weight: 600;
    }

    .ant-table-tbody > tr > td {
        font-size: 13px;
    }

    @media screen and (min-width: 769px) {
        .subtypes-container .ant-table-tbody > tr > td {
            display: table-cell !important;
            padding: 8px !important;
            border-bottom: 1px solid #f0f0f0;
            text-align: center !important;
        }

        .subtypes-container .ant-table-tbody > tr {
            display: table-row !important;
            margin-bottom: 0;
            background: transparent;
            border-radius: 0;
            border: none;
            box-shadow: none;
        }

        .subtypes-container .subtype-cell {
            font-size: 12px;
            font-weight: bold;
            display: flex;
            justify-content: flex-start;
            padding-left: 30px;
        }

        .subtypes-container .amount-cell {
            font-size: 12px;
            font-weight: bold;
            display: flex;
        }
    }

    @media screen and (max-width: 768px) {
        .ant-table {
            overflow-x: visible;
            width: 100%;
            max-width: 100%;
        }

        .ant-table table {
            min-width: 100%;
            width: 100%;
            max-width: 100%;
            table-layout: auto;
        }

        .ant-table-thead > tr > th {
            display: none !important;
        }

        .ant-table table th {
            display: none !important;
        }

        .ant-table table td {
            display: flex !important;
            justify-content: space-between;
            align-items: center;
            padding: 14px 16px !important;
            text-align: left;
            border-bottom: 1px solid #f0f0f0;
            font-size: 14px;
            min-height: 48px;
            width: 100%;
            box-sizing: border-box;
            gap: 12px;
        }

        .ant-table table td.ant-table-row-expand-icon-cell {
            padding: 8px;
            width: 60px;
            min-width: 60px;
            max-width: 60px;
            flex: 0 0 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom: 1px solid #f0f0f0;
        }

        .ant-table table td.ant-table-row-expand-icon-cell::before {
            display: none;
        }

        .ant-table table td::before {
            content: attr(data-label);
            font-weight: 600;
            color: #333;
            text-align: left;
            flex-shrink: 0;
            font-size: 14px;
            min-width: 120px;
            max-width: 120px;
            display: block;
            line-height: 1.5;
        }

        .ant-table table td[data-label=""]::before,
        .ant-table table td:not([data-label])::before {
            display: none;
        }

        .ant-table table td[data-label=""] {
            justify-content: center;
        }

        .ant-table table td > * {
            text-align: left;
            flex: 1;
            word-wrap: break-word;
            overflow-wrap: break-word;
            word-break: normal;
            white-space: normal;
            line-height: 1.5;
            min-width: 0;
        }

        .ant-table table td > span {
            display: inline;
        }

        .ant-table table td > div {
            display: block;
        }

        .ant-table table td a,
        .ant-table table td button {
            white-space: nowrap;
        }

        .ant-table-cell {
            flex-direction: row;
            align-items: center;
            padding: 10px 12px !important;
        }

        .ant-table table tbody tr {
            display: block;
            margin-bottom: 20px;
            background: white;
            border-radius: 12px;
            border: 1px solid #e8e8e8;
            box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
        }

        .ant-table table tbody tr td {
            display: flex !important;
            border-bottom: 1px solid #f5f5f5;
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
        }

        .ant-table table tbody tr td > * {
            display: inline-block;
        }

        .ant-table table tbody tr td:first-child {
            padding-top: 16px !important;
            border-top-left-radius: 12px;
            border-top-right-radius: 12px;
        }

        .ant-table table tbody tr td:last-child {
            padding-bottom: 16px !important;
            border-bottom: none;
            border-bottom-left-radius: 12px;
            border-bottom-right-radius: 12px;
        }

        .ant-table-expanded-row + .ant-table-row td:first-child,
        .ant-table-row.ant-table-row-level-0.ant-table-expanded-row-level-1 td:first-child {
            border-top-left-radius: 0 !important;
            border-top-right-radius: 0 !important;
        }

        .ant-table-row-level-0:has(+ .ant-table-expanded-row) td:last-child {
            border-bottom-left-radius: 0 !important;
            border-bottom-right-radius: 0 !important;
            border-bottom: 1px solid #f0f0f0 !important;
        }

        .ant-table-tbody > tr:hover > td {
            background: #fafafa;
        }

        .ant-table-expanded-row > td {
            padding: 0 !important;
            display: block !important;
            background-color: #f8f9fa;
            border-bottom-left-radius: 12px;
            border-bottom-right-radius: 12px;
            width: 100% !important;
            max-width: 100% !important;
            box-sizing: border-box !important;
        }

        .ant-table-expanded-row > td.ant-table-cell {
            border-top: 1px solid #f0f0f0;
        }

        .ant-table-expanded-row > td::before {
            display: none !important;
        }

        .ant-table-expanded-row .ant-table-expanded-row-content {
            padding: 0 !important;
            background-color: transparent;
            border-radius: 0;
            margin: 0;
            width: 100% !important;
            max-width: 100% !important;
            box-sizing: border-box !important;
            overflow-x: visible !important;
        }

        .ant-table-expanded-row .ant-table-expanded-row-content > div:not([class*="styled"]) {
            display: flex;
            flex-direction: column;
            gap: 0;
        }

        .ant-table-expanded-row .ant-table-expanded-row-content > div:not([class*="styled"]) > div {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 12px 0;
            border-bottom: 1px solid #e8e8e8;
        }

        .ant-table-expanded-row
            .ant-table-expanded-row-content
            > div:not([class*="styled"])
            > div:last-child {
            border-bottom: none;
            padding-bottom: 0;
        }

        .ant-table-expanded-row
            .ant-table-expanded-row-content
            > div:not([class*="styled"])
            > div:first-child {
            padding-top: 0;
        }

        .ant-table-expanded-row
            .ant-table-expanded-row-content
            > div:not([class*="styled"])
            > div
            > strong {
            font-weight: 600;
            color: #333;
            font-size: 14px;
            flex-shrink: 0;
            text-align: left;
            min-width: 120px;
            max-width: 120px;
            display: block;
            line-height: 1.5;
        }

        .ant-table-expanded-row
            .ant-table-expanded-row-content
            > div:not([class*="styled"])
            > div
            > span {
            text-align: left;
            font-size: 14px;
            word-wrap: break-word;
            overflow-wrap: break-word;
            word-break: normal;
            white-space: normal;
            line-height: 1.5;
            flex: 1;
            min-width: 0;
        }

        .ant-table-expanded-row {
            background: white;
            margin-bottom: 20px;
            display: block;
            width: 100% !important;
            max-width: 100% !important;
            box-sizing: border-box !important;
        }

        .ant-table-expanded-row:hover > td {
            background: #f8f9fa;
        }

        .ant-table tbody tr.ant-table-row-level-0:not(.ant-table-expanded-row) {
            border-bottom-left-radius: 12px;
            border-bottom-right-radius: 12px;
        }

        .ant-table tbody tr.ant-table-row-level-0:has(+ .ant-table-expanded-row) {
            margin-bottom: 0;
            box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }

        .ant-table tbody .ant-table-expanded-row {
            border-bottom-left-radius: 12px;
            border-bottom-right-radius: 12px;
            width: 100% !important;
            max-width: 100% !important;
        }

        .ant-table-row-expand-icon {
            color: #000;
            position: relative;
            border: none;
        }

        .ant-table-row-expand-icon:hover {
            color: #000;
            border: none;
        }

        /* Ant Design'ın default icon'unu gizle */
        .ant-table-row-expand-icon > .anticon {
            display: none;
        }

        /* Yatay çizgi - her zaman görünür */
        .ant-table-row-expand-icon::before {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 14px;
            height: 2px;
            background-color: #000;
        }

        /* Dikey çizgi - collapsed durumda görünür (plus için) */
        .ant-table-row-expand-icon::after {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 2px;
            height: 14px;
            background-color: #000;
            transition: transform 0.2s ease, opacity 0.2s ease;
        }

        /* Expanded durumda dikey çizgiyi gizle (minus için) */
        .ant-table-row-expand-icon-expanded::after {
            transform: translate(-50%, -50%) rotate(90deg);
            opacity: 0;
        }

        /* Subtypes container responsive styling */
        .subtypes-container .ant-table {
            width: 100%;
        }

        .subtypes-container .ant-table table {
            width: 100%;
        }

        .subtypes-container .ant-table-tbody > tr > td {
            display: block !important;
            padding: 8px 12px !important;
            border-bottom: 1px solid #f0f0f0;
            text-align: left !important;
        }

        .subtypes-container .ant-table-tbody > tr {
            display: block !important;
            margin-bottom: 8px;
            background: white;
            border-radius: 6px;
            border: 1px solid #dee2e6;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }

        .subtypes-container .subtype-cell {
            font-size: 14px;
            font-weight: bold;
            color: #495057;
            margin-bottom: 4px;
        }

        .subtypes-container .amount-cell {
            font-size: 14px;
            font-weight: bold;
            color: #28a745;
        }

        .ant-table-pagination {
            margin: 16px 0;
            text-align: center;
        }
    }

    @media screen and (max-width: 480px) {
        .ant-table table td {
            font-size: 13px;
            padding: 12px 14px !important;
            gap: 10px;
        }

        .ant-table table td::before {
            font-size: 13px;
            min-width: 100px;
            max-width: 100px;
            line-height: 1.5;
        }

        .ant-table table td > * {
            font-size: 13px;
        }

        .ant-table table tbody tr {
            margin-bottom: 16px;
        }

        .ant-table-row-expand-icon {
            width: 36px;
            height: 36px;
        }

        .ant-table-row-expand-icon::before {
            width: 12px;
        }

        .ant-table-row-expand-icon::after {
            height: 12px;
        }

        .ant-table table td.ant-table-row-expand-icon-cell {
            width: 52px;
            min-width: 52px;
            max-width: 52px;
            flex: 0 0 52px;
        }
    }
`;

export const TableWrapper = ({
    children,
    columns,
    renderTitle = () => null,
    style = {},
    ...tableProps
}) => {
    const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;

    const getColumnTitle = col => {
        if (!col.title) return "";
        if (typeof col.title === "string") return col.title;
        if (React.isValidElement(col.title)) {
            return col.title.props?.children || "";
        }
        return String(col.title);
    };

    const extractedColumns = React.useMemo(() => {
        if (columns) return columns;

        if (children && React.Children.count(children) > 0) {
            const cols = [];
            React.Children.forEach(children, child => {
                if (child && child.props) {
                    cols.push({
                        title: child.props.title,
                        dataIndex: child.props.dataIndex,
                        key: child.props.key || child.props.dataIndex,
                        width: child.props.width,
                        render: child.props.render,
                        align: child.props.align,
                        ...child.props
                    });
                }
            });
            return cols;
        }

        return null;
    }, [children, columns]);

    const modifiedColumns =
        extractedColumns && isMobile
            ? extractedColumns.map(col => ({
                  ...col,
                  onCell: (record, index) => {
                      const existingOnCell = col.onCell ? col.onCell(record, index) : {};
                      return {
                          ...existingOnCell,
                          "data-label": getColumnTitle(col)
                      };
                  }
              }))
            : extractedColumns;

    return (
        <Wrapper style={style}>
            {renderTitle()}
            <StyledTable
                size="small"
                style={{width: "100%"}}
                columns={modifiedColumns || extractedColumns}
                {...tableProps}
            >
                {!extractedColumns ? children : null}
            </StyledTable>
        </Wrapper>
    );
};
